<template>
  <div class="search-administrators container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>



    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item"> <a class="nav-link active"  @click="search();" data-toggle="tab" href="#org-tab" role="tab"><span class="hidden-sm-up"><i class="ti-home"></i></span> <span class="hidden-xs-down">Org</span></a> </li>
                <li class="nav-item"> <a class="nav-link" @click="getInvoices();" data-toggle="tab" href="#billing-tab" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">Billing</span></a> </li>
            </ul>
            <div class="result tab-content tabcontent-border">
              <!-- ORG TAB -->
              <div class="tab-pane active table-responsive" id="org-tab">
                <div class="result">
                  <div class="">
                    <div class="table-responsive">
                      <form v-on:submit.prevent>
                        <table class="table table-sm table-hover org-table">
                          <thead>
                            <tr>
                              <!--<th class="text-center result-label">ID</th>-->
                              <th class="result-label">Organization</th>
                              <th class="result-label">Address</th>
                              <th class="result-label">Phone</th>
                              <th class="result-label">Administrator</th>
                              <th class="result-label">Domain</th>
                              <th class="result-label">Market</th>
                              <th class="result-label">Allow Indviduals</th>
                              <th class="result-label"></th>
                            </tr>
                          </thead>
                          <tbody class="col-12">
                          <tr v-for="(admin, index) in data">
                            <td class="result-item">
                                <div class="logo-container" v-bind:style='{ backgroundImage : "url(" + admin.header_url + ")" }'>
                                </div>
                                <span class="org-title">
                                  {{ admin.name }}
                                </span>
                            </td>
                            <td class="result-item">
                                <span>
                                  {{ admin.address }}
                                </span>
                            </td>
                            <td class="result-item">
                                <span>
                                  {{ admin.phone }}
                                </span>
                            </td>
                            <td class="result-item">
                              {{ (admin.administrator) ? admin.administrator.name_first + ' ' + admin.administrator.name_last : '' }}
                            </td>
                            <td class="result-item">
                              <div>
                                <span>
                                  {{ admin.domain }}
                                </span>
                              </div>
                            </td>
                            <td class="result-item">
                              <div>
                                <span>
                                  {{ (admin.market) ? admin.market : 'All' }}
                                </span>
                              </div>
                            </td>                        
                            <td class="result-item">
                              <div>
                                <span>
                                  {{ (admin.allow_individual) ? 'Y' : 'N' }}
                                </span>
                              </div>
                            </td>                        

                            <td class="result-item">
                              <font-awesome-icon  @click="setUpdateOrg(admin)" icon="edit" style="color: #26a69a; cursor: pointer"/>
                              <font-awesome-icon v-if="roles[index]!='superuser' && getUser('id_user') != admin.id_user" @click="deleteOrg(admin);" icon="trash-alt" style="color: #ef5350; cursor: pointer"/>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </form>

                    </div>

                    <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                      <div style="margin: 1rem 1rem; float: left;">
                        <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                        <span v-else>Showing 0 entries</span>
                      </div>

                      <div style="margin: 0 1rem; float: right;">
                        <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                        </b-pagination>
                      </div>
                    </div>
                    <button @click="showAddUpdateModal = true;" class="btn btn-info waves-effect waves-light m-t-10" style="float:right;">New Org</button>
                  </div>
                </div>
              </div>
              <!-- BILLING TAB -->
              <div class="tab-pane table-responsive" id="billing-tab">
                <div>
                  <div class="table-header-filter" style="width: 200px">
                    <label>Organization: </label>
                    <select v-model="organizationInvoiceFilter" class="form-control table-select" v-on:change="getInvoices(1)">
                      <option value="all">All</option>
                      <option v-for="(org) in data" v-bind:key="org.id" v-bind:value="org.id">
                        {{org.name}}
                      </option>
                    </select>
                  </div>                  
                </div>
                <div class="result">
                  <div v-for="(invoice, index) in invoices" v-bind:key="index">
                    <BookingOrganizationsInvoice  v-bind:invoice="invoice" v-bind:key="name"></BookingOrganizationsInvoice>
                  </div>
                  <div class="">


                    <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                      <div style="margin: 1rem 1rem; float: left;">
                        <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalInvoiceRows ? totalInvoiceRows : perPage * currentPage }} of {{ totalInvoiceRows }} entries</span>
                        <span v-else>Showing 0 entries</span>
                      </div>

                      <div style="margin: 0 1rem; float: right;">
                        <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalInvoiceRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                        </b-pagination>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    <modal v-if="showAddUpdateModal" @close="showAddUpdateModal = false">
      <h3 slot="header">
        <span v-if="!updateOrgObj">New Booking Organization</span>
        <span v-if="updateOrgObj">Update Booking Organization</span>
      </h3>
      <div slot="body">
        <!-- <div class="row">
          <div class="col-12"> -->
            <!-- <div class="card">
              <div class="card-body"> -->
                <form v-on:submit.prevent class="form-material">
                  <div class="row">
                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Name*</label>
                        <input v-model="name" class="form-control" placeholder="Organization Name" style="width:100%" type="text">
                      </div>
                    </div>

                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Address*</label>
                        <input v-model="address" class="form-control" placeholder="Organization Address" style="width:100%" type="text">
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Phone</label>
                        <input v-model="phone" class="form-control" placeholder="Phone" style="width:100%" type="text">
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Logo*</label>
                        <div style="width:300px; height: 100px">
                          <div v-if="this.logoUrl" @click="logoUrl = ''" class="logo-container logo-input" v-bind:style='{ backgroundImage : "url(" + this.logoUrl + ")" }' style="width:300px; height: 100px">
                            <div class="replace-overlay">Replace</div>
                          </div>
                          <vue-dropzone v-if="!this.logoUrl" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot=true style="border:dotted 2px grey; border-radius: 8px;"
                                        v-on:vdropzone-error="vUploadError"
                                        v-on:vdropzone-success="vdropzoneSuccess"
                                        v-on:vdropzone-processing="vdropzoneAdded"
                          >
                            <div class="dropzone-custom-content">
                              <h4 class="dropzone-custom-title">Drag and drop logo here</h4>
                              <div class="subtitle">...or click to select a file</div>
                            </div>
                          </vue-dropzone>
                          
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Tax ID*</label>
                        <input v-model="tax_id" class="form-control" placeholder="Tax ID" style="width:100%" type="text">
                      </div>
                    </div>


                    <div class="col-md-3 col-lg-3 p-0">
                      <div class="m-3">
                        <label class="search-label">Administrator</label>
                        <input v-model="administrator_name" class="form-control" placeholder="Administrator Name" style="width:100%" type="text">
                      </div>
                    </div>                
                    <div class="col-md-3 col-lg-3 p-0">
                      <div class="m-3">
                        <label class="search-label">Administrator Phone</label>
                        <input v-model="administrator_phone" class="form-control" placeholder="Administrator Phone" style="width:100%" type="text">
                        <!-- <button v-on:click="togglePass()" class="btn btn-info waves-effect waves-light m-t-5">Show Password</button> -->
                      </div>
                    </div>
                    <div class="col-md-3 col-lg-3 p-0">
                      <div class="m-3">
                        <label class="search-label">Administrator Email</label>
                        <input v-model="administrator_email" class="form-control" placeholder="Administrator Email" style="width:100%" type="text">
                      </div>
                    </div>

                    <div class="col-md-3 col-lg-3 p-0">
                      <div class="m-3">
                        <label class="search-label">Administrator Password</label>
                        <input v-model="administrator_password" class="form-control" placeholder="Administrator Password" style="width:100%" type="password" id="passwordInput">
                        <!-- <button v-on:click="togglePass()" class="btn btn-info waves-effect waves-light m-t-5">Show Password</button> -->
                      </div>
                    </div>

                    <div class="col-md-3 col-lg-3 p-0">
                      <div class="m-3">
                        <label class="search-label">Billing Contact</label>
                        <input v-model="billing_contact_name" class="form-control" placeholder="Billing Contact Name" style="width:100%" type="text">
                      </div>
                    </div>                
                    <div class="col-md-3 col-lg-3 p-0">
                      <div class="m-3">
                        <label class="search-label">Billing Contact Email</label>
                        <input v-model="billing_contact_email" class="form-control" placeholder="Billing Contact Email" style="width:100%" type="text">
                      </div>
                    </div>

    
                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Domain</label>
                        <input v-model="domain" class="form-control" placeholder="Domain" style="width:100%" type="text">
                      </div>
                    </div>

                    <!-- <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Organization Size</label>
                        <input v-model="size" class="form-control" placeholder="Organization Size" style="width:100%" type="text">
                      </div>
                    </div>

                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Estimated Monthly Ride Volume</label>
                        <input v-model="estimated_monthly_ride_volume" class="form-control" placeholder="Volume" style="width:100%" type="text">
                      </div>
                    </div>                 -->

                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <label class="search-label">Market</label>
                        <select type="text" placeholder="Market"
                                class="form-control ddown" id="market-filter" v-model="selected_market">
                          <option v-bind:value="'All'">
                            All
                          </option>
                          <option v-for="market in markets" v-bind:value="market.id_market">
                            {{ market.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-12 p-0">
                      <div class="m-3">
                        <input
                          type="checkbox"
                          v-model="allow_individuals"
                          id="allow_individuals_checkbox"
                        >
                        <label class="search-label" for="allow_individuals_checkbox" >Allow Individual Bookers</label>                    
                      </div>
                    </div>

                    <!-- <div class="col-2 m-3 p-0 submit-button">

                      <button  v-if="!updateOrgObj" v-on:click="addOrg()" class="btn btn-info waves-effect waves-light m-t-10">Add</button>

                      <button v-if="updateOrgObj" v-on:click="updateOrg()" class="btn btn-info waves-effect waves-light m-t-10">Update</button>
                      <button v-if="updateOrgObj" v-on:click="cancelUpdateOrg()" class="btn btn-info waves-effect waves-light m-t-10">Cancel</button>


                    </div> -->
                  </div>
                </form>
              <!-- </div>
            </div> -->

          <!-- </div>
        </div> -->

      </div>
      <div slot="footer" >
        <button  v-if="!updateOrgObj" v-on:click="addOrg()" class="btn btn-info waves-effect waves-light m-t-10">Add</button>

        <button v-if="updateOrgObj" v-on:click="updateOrg()" class="btn btn-info waves-effect waves-light m-t-10">Update</button>
        <button v-on:click="cancelUpdateOrg()" class="btn btn-info waves-effect waves-light m-t-10">Cancel</button>
      </div>      
    </modal>
  </div>
  
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  // register modal component
  Vue.component('modal', {
    template: '#modal-template'
  })
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import BookingOrganizationsInvoice from './BookingOrganizationsInvoice.vue'



  export default {
    metaInfo: {
      title: 'Wingz Support | Settings',
    },
    name: 'BookingOrganizations',
    data () {
      return {
        title: 'Booking Organizations',
        previousAdmin: null,
        data: {},
        invoices: {},
        email: '',
        name: null,
        domain: null,
        logoUrl: '',
        address: '',
        phone: '',
        tax_id: '',
        administrator_name: '',
        administrator_email: '',
        administrator_password: '',
        administrator_phone: '',
        administrator: null,
        billing_contact_name: '',
        billing_contact_email: '',
        size: '',
        estimated_monthly_ride_volume: '',
        allow_individuals: false,
        password: null,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        totalInvoiceRows: 0,
        perPage: 20,
        limit: 10,
        roles: [],
        role: 'admin',
        input_admin:null,
        errors: null,
        non_field_errors: null,
        field_name: {
          'address': 'Organization address',
          'name': 'Organization name',
          'estimated_monthly_ride_volume': 'Estimated monthly ride volume',
          'domain': 'Domain',
          'phone': 'Phone',
          'tax_id': 'Tax ID',
          'billing_contact_name': 'Billing contact',
          'billing_contact_email': 'Billing email',
          'size': 'Organization size',

          'administrator_name': 'Admin name',
          'administrator_email': 'Admin email',
          'administrator_password': 'Admin password',
          'administrator_phone': 'Admin phone',


          // header_url: this.logoUrl,

        },
        email_bk: null,
        name_first_bk: null,
        name_last_bk: null,
        id_market_bk: null,
        markets: null,
        selected_market: 'All',
        updateOrgObj: null,
        showAddUpdateModal: false,
        organizationInvoiceFilter: 'all',
        dropzoneOptions: {
          url: process.env.API_BASE_URL_CS + 'images/',
          thumbnailWidth: 150,
          maxFilesize: 2.5,
          addRemoveLinks: true,
          headers: {
            "Authorization": "jwt " + this.getUser().token
          }
        },        
      }
    },
    components: {
      Loading,
      vueDropzone: vue2Dropzone,
      BookingOrganizationsInvoice
    },
    computed: {
      selected_market_name: function (id_market) {
        if (this.markets) {
          for (var i=0; i < this.markets.length; i++) {
            var m = this.markets[i]
            if (m.id_market == id_market) {
              return m.name;
            }
          }
        }
        return 'All'
      }
    },  
    methods: {
      vUploadError: function (file, message, xhr) {
        console.error(message)
      },
      vdropzoneSuccess: function (file, response) {
        // this.imageLinks.push(response.url)
        this.logoUrl = response.url
      },
      vdropzoneAdded: function (file) {
        console.log('---')
        this.logoUrl = ''
      },
      changePreviousAdmin(admin) {
        if (this.previousAdmin) {
          this.previousAdmin.edit = false
        }
        this.previousAdmin = admin
      },
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'booking-organizations/')
          .then(response => {
            console.log(response.data)

            // for( let index in response.data.results) {
            //   response.data.results[index]['edit'] = false
            // }

            this.data = response.data



            if (response.data && response.data.length) {
              this.totalRows = response.data.length
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      getInvoices: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'invoices/'
            + (this.organizationInvoiceFilter == "all" ? '' : '?id_booking_org=' + this.organizationInvoiceFilter)
          )
          .then(response => {
            console.log(response.data)

            this.invoices = response.data

            if (response.data && response.data.length) {
              this.totalInvoiceRows = response.data.length
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },      
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        console.log('change to page: ' + page)
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      setUpdateOrg(admin) {
        if (!admin) {
          return
        }

        this.name = admin.name
        this.domain = admin.domain
        this.logoUrl = admin.header_url
        this.address = admin.address
        this.phone = admin.phone
        this.tax_id = admin.tax_id
        this.administrator_name = (admin.administrator) ? admin.administrator.name_first + ' ' + admin.administrator.name_last : ''
        this.administrator_email = (admin.administrator) ? admin.administrator.email : ''
        this.administrator_password = (admin.administrator) ? '*******' : ''
        this.administrator_phone = (admin.administrator) ? admin.administrator.phone_number : ''

        this.billing_contact_name = admin.billing_contact_name
        this.billing_contact_email = admin.billing_contact_email
        this.size = admin.size
        this.estimated_monthly_ride_volume = admin.estimated_monthly_ride_volume

        this.updateOrgObj = admin

        this.showAddUpdateModal = true
        this.selected_market = (admin.market) ? admin.market : 'All'
        this.allow_individuals =admin.allow_individual
      },
      cancelUpdateOrg() {
        this.name = null
        this.domain = null
        this.logoUrl = ''
        this.address = ''    
        this.phone = ''
        this.tax_id = ''
        this.administrator_name = ''
        this.administrator_email = ''
        this.administrator_password = ''
        this.administrator_phone = ''
        this.billing_contact_name = ''
        this.billing_contact_email = ''
        this.size = null
        this.estimated_monthly_ride_volume = null
        this.selected_market = 'All'
        this.updateOrgObj = null
        this.allow_individuals = false

        this.showAddUpdateModal = false;
      },      
      updateOrg(admin) {
        // partial update
        this.isLoading = true

        var params = {
            // email: admin.email.replace('\n', '').trim(),
            // name_first: !admin.name_first ? '' : admin.name_first.replace('\n', '').trim(),
            // name_last: !admin.name_last ? '' : admin.name_last.replace('\n', '').trim(),
            // id_market: admin.id_market == 'null' ? '' : admin.id_market

            name: this.name,
            domain: this.domain,
            header_url: this.logoUrl,
            address: this.address,
            phone: this.phone,
            tax_id: this.tax_id,
            administrator_name: this.administrator_name,
            administrator_email: this.administrator_email,
            administrator_password: this.administrator_password,
            administrator_phone: this.administrator_phone,
            billing_contact_name: this.billing_contact_name,
            billing_contact_email: this.billing_contact_email,
            allow_individual: this.allow_individuals
        }
        if (this.selected_market && this.selected_market !== 'All') {
          params['market'] = this.selected_market
        }        
        if (this.size) {
          params['size'] = this.size
        }
        if (this.estimated_monthly_ride_volume) {
          params['estimated_monthly_ride_volume'] = this.estimated_monthly_ride_volume
        }

        this.$http
          .patch(process.env.API_BASE_URL_CS + 'booking-organizations/' + this.updateOrgObj.id + '/', params)
          .then(response => {
            this.cancelUpdateOrg()

            // update list
            this.search()
          })
          .catch(error => {
            console.log(error)
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            this.isLoading = false


            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              if (Array.isArray(error)) {
                error = error[0]
              } else {
                let name = Object.keys(error)[0]
                error = error[name][0].replace('This field', this.field_name[name])
                error = error.replace('this field', this.field_name[name])
                error = error.replace('Enter a valid email address.', 'Invalid email address.')
              }
            }

            this.showToastError(error)
          })
          .finally()
      },
      addOrg() {
        // if (this.email.indexOf('@') == -1 || this.email.indexOf('.') == -1) {
        //   alert('please enter a valid email')
        //   return
        // }

        this.isLoading = true
        var params = {
          name: this.name,
          domain: this.domain,
          header_url: this.logoUrl,
          address: this.address,
          phone: this.phone,
          tax_id: this.tax_id,
          administrator_name: this.administrator_name,
          administrator_email: this.administrator_email,
          administrator_password: this.administrator_password,
          administrator_phone: this.administrator_phone,
          billing_contact_name: this.billing_contact_name,
          billing_contact_email: this.billing_contact_email,
          allow_individual: this.allow_individuals
        }
        if (this.size) {
          params['size'] = this.size
        }
        if (this.estimated_monthly_ride_volume) {
          params['estimated_monthly_ride_volume'] = this.estimated_monthly_ride_volume
        }
        if (this.selected_market && this.selected_market !== 'All') {
          params['market'] = this.selected_market
        }

        this.$http
          .post(process.env.API_BASE_URL_CS + 'booking-organizations/', params)
          .then(response => {
            this.cancelUpdateOrg()

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)

            this.isLoading = false

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              let name = Object.keys(error)[0]
              error = error[name][0].replace('This field', this.field_name[name])
              error = error.replace('this field', this.field_name[name])
              error = error.replace('Enter a valid email address.', 'Invalid email address.')
            }

            this.showToastError(error)
          })
      },
      changeRole(admin, index) {
        // partial update
        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=update_admin_role', {
            is_admin: this.roles[index] == 'admin',
            is_agent: this.roles[index] == 'agent'
          })
          .then(response => {
            console.log(response.data)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      deleteOrg(admin) {
        if(!confirm("Are you sure you want to remove this booking organization?")) {
          return
        }

        this.isLoading = true
        this.$http
          .delete(process.env.API_BASE_URL_CS + 'booking-organizations/' + admin.id + '/', {})
          .then(response => {
            console.log(response.data)

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errored = true
            this.isLoading = false
          })
      },
      togglePass() {
        var x = document.getElementById("passwordInput");
        if (x.type === "password") {
          x.type = "text";
        } else {
          x.type = "password";
        }
      },
      getMarkets: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            console.log('markets response', response.data)
            this.markets = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },
    },
    getMarketName: function(id_market) {
      if (this.markets) {
        for(var i=0; i<this.markets.length;i++) {
          if (this.markets[i].id_market == id_market) {
            return this.markets[i].id_market
          }
        }
      }
      return 'All'
    },
    mounted () {
      console.log("Mounted")
      this.search()
      this.getMarkets()
    },
    created () {
      // document.title = "Wingz Support | Settings";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }

  .add-admin-btn {
    color: #333268;
    background-color: #00f9b9;
    border: none;
    margin-left: 5px;
  }

  .add-admin-btn:hover {
    background-color: red;
  }

  .add-admin-panel {
    max-width: 400px;
  }
  .form-check {
    display: inline-block;
    padding-left: 0px;
    padding-right: 10px;
  }
  .dropzone {
      min-height: 100px;
      border: 2px solid rgba(0, 0, 0, 0.3);
      background: white;
      padding: 20px 20px;
  }  
  .dropzone .dz-message {
      text-align: center;
      margin: 0.5em 0;
      padding:0px;
  } 
  .dropzone .dz-preview {
    display: none;
  }

  .logo-container {
    width: 140px;
    height: 40px;
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    align-content: center;    
  }

  .modal-mask {
    width: 80%;
    overflow: scroll;
  }
  .modal-body {
    max-height: 80vh;
    overflow: auto;    
  }
  .org-table td{
    vertical-align: middle;
  }
  .org-table td span.org-title {
    margin: 20px 10px;
    line-height: 40px;
    vertical-align: top;
  }
  .logo-input {
    position: relative;
  }
  .logo-input .replace-overlay {
    display: none;
  }
  .logo-input:hover .replace-overlay {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: #88888888;
    text-align: center;
    margin: auto;
    color: black;
    font-size: 20px;
    font-weight: bold;
    padding: 32px;
  }  


  .nav-tabs .nav-link{
      border-color: #e9ecef #e9ecef #dee2e6;
      color:darkgray;
  }
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
      color: #000000;
      font-weight: bold;
  }
  .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
      border-color: #e9ecef #e9ecef #dee2e6;
  }  
</style>



// WEBPACK FOOTER //
// src/components/BookingOrganizations.vue